import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {PropositionBetsViewModel} from "../../../domain/bets/proposition/models/proposition-bets.view-model";
import type {PropositionBetsWidgetState} from "../models/proposition-bets-widget.state";
import type {PropositionBetsDomainModel} from "../../../domain/bets/proposition/models/proposition-bets.domain-model";

export class PropositionBetsWidgetPopulateDataHandler extends PopulateDataHandler {
  state: PropositionBetsWidgetState;

  async action(params) {
    this.state.bets = params.dataSource.propositionBets?.map((propBet: PropositionBetsDomainModel) => new PropositionBetsViewModel(propBet));

    super.action(params)
  }
}
